/* eslint-disable no-underscore-dangle */
import React from 'react';
import { Card, Spinner } from 'react-bootstrap';
import Error from '../../../Components/Error';
import { ReceiptReviewRow } from '../../../Components/TripClaims/TripClaimRows';
import { expenseAdjustmentDescription } from '../../../Utils/tripClaims';

export { PHOTO_URL_FRESH_MS } from '../../../Hooks/useBookingClaims';
export { expenseAdjustmentDescription };

/**
 * Receipts a driver — or an operator login, for its own trip — submitted from
 * the portal for this booking, each named by who filed it. Staff look at the
 * receipt, confirm where its cost goes (pre-selected: the vehicle's own cost
 * bucket, or the operator on the trip when it has none) and approve: the
 * decision and the ledger line are written together. "Create line item"
 * remains for an approved receipt whose cost was absorbed and later needs one
 * anyway.
 *
 * `claims` is the booking's useBookingClaims state (shared with the Order
 * Details banner); the rows are the Trip claims page's own.
 */
function DriverExpensesSection({ claims, onCreateLineItem }) {
  const {
    expenses, loading, loaded, error, setError, busyId, reviewReceipt, openPhoto,
  } = claims;

  return (
    <Card className="mb-3" data-testid="driver-expenses-section" data-loaded={loaded}>
      <Card.Header className="fw-bold d-flex align-items-center">
        <span>
          <i className="fa fa-receipt me-2" />
          Expenses
        </span>
        {loading && <Spinner animation="border" size="sm" className="ms-2" />}
      </Card.Header>
      <Card.Body>
        <Error error={error} setError={setError} />

        {loaded && expenses.length === 0 && (
          <p className="text-muted mb-0">No expenses submitted for this booking.</p>
        )}

        {expenses.map((expense) => (
          <ReceiptReviewRow
            key={expense._id}
            expense={expense}
            busy={busyId === expense._id}
            onReview={(decision, orderLine) => reviewReceipt(expense, decision, orderLine)}
            onCreateLineItem={onCreateLineItem ? () => onCreateLineItem({ kind: 'receipt', expense }) : undefined}
            onOpenPhoto={openPhoto}
          />
        ))}
      </Card.Body>
    </Card>
  );
}

export default DriverExpensesSection;
